import { render, staticRenderFns } from "./batch.vue?vue&type=template&id=6e0928bd&scoped=true&"
import script from "./batch.vue?vue&type=script&lang=js&"
export * from "./batch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0928bd",
  null
  
)

export default component.exports